import cn from 'classnames';
import ImpressionTrackerNew from 'components/impression-tracker/new-impression-tracker';
import { FilterConfig, possibleTags } from 'interfaces/collection-filter';
import { CollectionProduct } from 'models/collection/collection';
import { useAvailableFilterMap } from 'modules/collection/state/available-choices';
import { FormattedMessage } from 'react-intl';
import HeroFilterButton from './filter-button';

interface HeroFilterContainerProps {
  category: keyof ReturnType<typeof useAvailableFilterMap>;
  className?: string;
  collectionProducts: CollectionProduct[];
  filterConfig: FilterConfig | undefined;
}

/**
 * A component that renders the main filter options with images for a collection
 */
const HeroFilterContainer: React.FC<HeroFilterContainerProps> = ({
  category,
  className,
  collectionProducts,
  filterConfig,
}) => {
  const availableFilterMap = useAvailableFilterMap(collectionProducts, filterConfig);

  const filters: possibleTags[] | undefined = availableFilterMap[category]?.tags;

  if (!filters || filters.length === 0) return null;

  return (
    <ImpressionTrackerNew element="Hero Filter">
      <div data-test="hero-filter" className={cn('flex items-center gap-5', className)}>
        <p className="hidden text-sm lg:block">
          <FormattedMessage id="landingpage:category-slider:title-EC" />:
        </p>
        <div className="grid grow auto-cols-fr grid-flow-col gap-2 lg:flex lg:grow-0">
          {filters?.map((filterName) => (
            <HeroFilterButton key={filterName} filterName={filterName} />
          ))}
        </div>
      </div>
    </ImpressionTrackerNew>
  );
};

export default HeroFilterContainer;
